var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 16.6667V3.33337V16.6667Z",
    fill: "#A93E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 16.6667V3.33337",
    stroke: "#A93E71",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 10.0001H16.6667H3.33337Z",
    fill: "#A93E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 10.0001H16.6667",
    stroke: "#A93E71",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlusIcon);
export default __webpack_public_path__ + "static/media/addPlusIcon.d3d0620e3bbc95af745ecd17cf90a88f.svg";
export { ForwardRef as ReactComponent };